export default __webpack_public_path__ + "static/media/person_3@3x.b4fe2e81.png";